function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPersonalDetails = function SvgPersonalDetails(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 26"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13 16.3c-.7 0-1.2 0-1.6.1-1.8.3-3.4 2.1-3.4 4.1 0 .5-.4.8-.8.8s-.8-.4-.8-.8c0-2.2 1.4-4.3 3.3-5.2-1.5-1.1-2.5-2.8-2.5-4.8 0-3.2 2.6-5.8 5.8-5.8s5.8 2.6 5.8 5.8c0 2-1 3.7-2.5 4.8 1.9 1 3.3 3.1 3.3 5.2 0 .5-.4.8-.8.8-.5 0-.8-.4-.8-.8 0-1.9-1.5-3.8-3.4-4.1-.4 0-.9-.1-1.6-.1m0-1.6c-2.3 0-4.2-1.9-4.2-4.2s1.9-4.2 4.2-4.2 4.2 1.9 4.2 4.2-1.9 4.2-4.2 4.2",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgPersonalDetails;